module.exports = __webpack_public_path__ + "media/images/adaptables-a4fe8014f27b03eeffe662612d18bd06.png";